export const iconNavigation = {
  "1": {
    "/": (
      <svg
        width="22"
        height="12"
        viewBox="0 0 22 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 0H0V12H22V0ZM10 7H7V10H5V7H2V5H5V2H7V5H10V7ZM14.5 9C13.67 9 13 8.33 13 7.5C13 6.67 13.67 6 14.5 6C15.33 6 16 6.67 16 7.5C16 8.33 15.33 9 14.5 9ZM18.5 6C17.67 6 17 5.33 17 4.5C17 3.67 17.67 3 18.5 3C19.33 3 20 3.67 20 4.5C20 5.33 19.33 6 18.5 6Z"
          fill="#7C7B73"
        />
      </svg>
    ),
    "/results": (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 5.5V0H7V5.5L10 8.5L13 5.5ZM5.5 7H0V13H5.5L8.5 10L5.5 7ZM7 14.5V20H13V14.5L10 11.5L7 14.5ZM14.5 7L11.5 10L14.5 13H20V7H14.5Z"
          fill="#7C7B73"
        />
      </svg>
    ),
    "/history": (
      <svg
        width="21"
        height="18"
        viewBox="0 0 21 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C7.03 0 3 4.03 3 9H0L3.89 12.89L3.96 13.03L8 9H5C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9C19 12.87 15.87 16 12 16C10.07 16 8.32 15.21 7.06 13.94L5.64 15.36C7.27 16.99 9.51 18 12 18C16.97 18 21 13.97 21 9C21 4.03 16.97 0 12 0ZM11 5V10L15.25 12.52L16.02 11.23L12.5 9.14V5H11Z"
          fill="#7C7B73"
        />
      </svg>
    ),
    "/chart": (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 4.2H3V14H0V4.2ZM5.6 0H8.4V14H5.6V0V0ZM11.2 8H14V14H11.2V8Z"
          fill="#7C7B73"
        />
      </svg>
    ),
  },
  "2":{
    "/":(  <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.40959 8.94158C7.65481 9.18679 7.65481 9.58436 7.40959 9.82957L4.85611 12.3831C4.61089 12.6283 4.21333 12.6283 3.96811 12.3831C3.7229 12.1378 3.7229 11.7403 3.96811 11.4951L6.5216 8.94158C6.76681 8.69636 7.16438 8.69636 7.40959 8.94158Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.99325 8.96692C4.23847 8.72171 4.63603 8.72171 4.88125 8.96692L7.43474 11.5204C7.67995 11.7656 7.67995 12.1632 7.43474 12.4084C7.18952 12.6536 6.79195 12.6536 6.54674 12.4084L3.99325 9.85491C3.74804 9.6097 3.74804 9.21213 3.99325 8.96692Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.44375 10.6749C9.44375 10.2125 9.81858 9.8377 10.281 9.8377H10.2893C10.7517 9.8377 11.1265 10.2125 11.1265 10.6749C11.1265 11.1373 10.7517 11.5121 10.2893 11.5121H10.281C9.81858 11.5121 9.44375 11.1373 9.44375 10.6749Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7423 10.6749C12.7423 10.2125 13.1171 9.8377 13.5795 9.8377H13.5879C14.0503 9.8377 14.4251 10.2125 14.4251 10.6749C14.4251 11.1373 14.0503 11.5121 13.5879 11.5121H13.5795C13.1171 11.5121 12.7423 11.1373 12.7423 10.6749Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9302 11.4786C12.3926 11.4786 12.7674 11.8534 12.7674 12.3158V12.3325C12.7674 12.7949 12.3926 13.1698 11.9302 13.1698C11.4679 13.1698 11.093 12.7949 11.093 12.3325V12.3158C11.093 11.8534 11.4679 11.4786 11.9302 11.4786Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9302 8.18004C12.3926 8.18004 12.7674 8.55487 12.7674 9.01725V9.03399C12.7674 9.49637 12.3926 9.8712 11.9302 9.8712C11.4679 9.8712 11.093 9.49637 11.093 9.03399V9.01725C11.093 8.55487 11.4679 8.18004 11.9302 8.18004Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.54437 4.8937C2.6616 3.77647 4.33342 3.34933 6.48837 3.34933H11.5116C13.6666 3.34933 15.3384 3.77647 16.4556 4.8937C17.5729 6.01093 18 7.68274 18 9.8377V11.5121C18 13.6671 17.5729 15.3389 16.4556 16.4561C15.3384 17.5733 13.6666 18.0005 11.5116 18.0005H6.48837C4.33342 18.0005 2.6616 17.5733 1.54437 16.4561C0.427145 15.3389 0 13.6671 0 11.5121V9.8377C0 7.68274 0.427145 6.01093 1.54437 4.8937ZM2.43237 5.78169C1.66588 6.54819 1.25581 7.8066 1.25581 9.8377V11.5121C1.25581 13.5432 1.66588 14.8016 2.43237 15.5681C3.19886 16.3346 4.45728 16.7447 6.48837 16.7447H11.5116C13.5427 16.7447 14.8011 16.3346 15.5676 15.5681C16.3341 14.8016 16.7442 13.5432 16.7442 11.5121V9.8377C16.7442 7.8066 16.3341 6.54819 15.5676 5.78169C14.8011 5.0152 13.5427 4.60514 11.5116 4.60514H6.48837C4.45728 4.60514 3.19886 5.0152 2.43237 5.78169Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.85178 0.000519709C10.1985 0.00395309 10.4769 0.287846 10.4734 0.634613L10.465 1.48539C10.4505 2.28154 9.80934 2.93072 8.99998 2.93072H8.97487C8.86938 2.93072 8.77394 3.01809 8.77394 3.14002C8.77394 3.25371 8.86956 3.34933 8.98324 3.34933H9.82045C10.1672 3.34933 10.4484 3.63045 10.4484 3.97723C10.4484 4.32402 10.1672 4.60514 9.82045 4.60514H8.98324C8.17599 4.60514 7.51812 3.94727 7.51812 3.14002C7.51812 2.34103 8.15943 1.67491 8.97487 1.67491H8.99998C9.11102 1.67491 9.20619 1.58819 9.20935 1.46437L9.21769 0.622179C9.22112 0.275413 9.50502 -0.00291372 9.85178 0.000519709Z"
        fill="#7C7B73"
      />
    </svg>),
    "/results":(
      <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.18594 9.16779C4.18594 8.82101 4.46706 8.5399 4.81384 8.5399H10.6742C11.0209 8.5399 11.302 8.82101 11.302 9.16779C11.302 9.51456 11.0209 9.79568 10.6742 9.79568H4.81384C4.46706 9.79568 4.18594 9.51456 4.18594 9.16779Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.18594 12.5165C4.18594 12.1698 4.46706 11.8887 4.81384 11.8887H8.48072C8.8275 11.8887 9.10861 12.1698 9.10861 12.5165C9.10861 12.8633 8.8275 13.1444 8.48072 13.1444H4.81384C4.46706 13.1444 4.18594 12.8633 4.18594 12.5165Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.42862 0.00012736C6.44919 0.000185793 6.46907 0.00024228 6.48821 0.00024228H9.83697C9.85611 0.00024228 9.876 0.000185793 9.89656 0.00012736C10.2674 -0.000926186 10.86 -0.00260961 11.3364 0.314994C11.9093 0.696924 12.1392 1.3824 12.1392 2.30251C12.1392 2.32166 12.1393 2.34154 12.1394 2.3621C12.1404 2.73296 12.1421 3.32553 11.8245 3.80194C11.4426 4.37483 10.7571 4.60478 9.83697 4.60478H6.48821C6.46907 4.60478 6.44919 4.60484 6.42862 4.6049C6.05776 4.60595 5.46519 4.60763 4.98879 4.29003C4.41589 3.9081 4.18594 3.22262 4.18594 2.30251C4.18594 1.3824 4.41589 0.696924 4.98879 0.314994C5.46519 -0.00260961 6.05776 -0.000926186 6.42862 0.00012736ZM5.68537 1.35987C5.63037 1.39653 5.44173 1.54824 5.44173 2.30251C5.44173 3.05678 5.63037 3.20849 5.68537 3.24515C5.81044 3.32853 6.0154 3.349 6.48821 3.349H9.83697C10.5912 3.349 10.7429 3.16035 10.7796 3.10535C10.863 2.98029 10.8835 2.77533 10.8835 2.30251C10.8835 1.54824 10.6948 1.39653 10.6398 1.35987C10.5147 1.27649 10.3098 1.25603 9.83697 1.25603H6.48821C6.0154 1.25603 5.81044 1.27649 5.68537 1.35987Z"
        fill="#7C7B73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.44081 2.28556C5.45953 2.63183 5.194 2.92771 4.84773 2.94643C3.50308 3.01911 2.66505 3.30165 2.13663 3.87364C1.6012 4.45321 1.25578 5.46795 1.25578 7.32584V12.349C1.25578 14.0122 1.47456 15.054 2.04227 15.7029C2.59183 16.3309 3.61219 16.7442 5.65102 16.7442H10.6742C12.713 16.7442 13.7334 16.3309 14.2829 15.7029C14.8506 15.054 15.0694 14.0122 15.0694 12.349V7.32584C15.0694 5.46334 14.7238 4.44909 14.1888 3.87082C13.6608 3.3 12.8231 3.01917 11.4775 2.94643C11.1312 2.92771 10.8657 2.63183 10.8844 2.28556C10.9031 1.93929 11.199 1.67376 11.5452 1.69248C12.9874 1.77043 14.2427 2.07983 15.1107 3.01804C15.9717 3.9488 16.3252 5.3624 16.3252 7.32584V12.349C16.3252 14.0345 16.1254 15.5042 15.228 16.5298C14.3125 17.5761 12.8213 18 10.6742 18H5.65102C3.50391 18 2.01271 17.5761 1.09719 16.5298C0.19982 15.5042 0 14.0345 0 12.349V7.32584C0 5.36616 0.353631 3.95305 1.21422 3.02149C2.08181 2.08236 3.33675 1.77049 4.77994 1.69248C5.12621 1.67376 5.4221 1.93929 5.44081 2.28556Z"
        fill="#7C7B73"
      />
    </svg>
    ),
    "/history":(
      <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.9535 5.02374C8.30028 5.02374 8.58141 5.30487 8.58141 5.65165V9.8377C8.58141 10.1845 8.30028 10.4656 7.9535 10.4656C7.60672 10.4656 7.32559 10.1845 7.32559 9.8377V5.65165C7.32559 5.30487 7.60672 5.02374 7.9535 5.02374Z" fill="#7C7B73"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.95349 3.34932C4.25655 3.34932 1.25581 6.35006 1.25581 10.047C1.25581 13.7439 4.25655 16.7447 7.95349 16.7447C8.30027 16.7447 8.5814 17.0258 8.5814 17.3726C8.5814 17.7194 8.30027 18.0005 7.95349 18.0005C3.56298 18.0005 0 14.4375 0 10.047C0 5.65649 3.56298 2.09351 7.95349 2.09351C12.344 2.09351 15.907 5.65649 15.907 10.047C15.907 10.3938 15.6259 10.6749 15.2791 10.6749C14.9323 10.6749 14.6512 10.3938 14.6512 10.047C14.6512 6.35006 11.6504 3.34932 7.95349 3.34932Z" fill="#7C7B73"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M4.81396 0.628395C4.81396 0.281612 5.09509 0.000488281 5.44187 0.000488281H10.4651C10.8119 0.000488281 11.093 0.281612 11.093 0.628395C11.093 0.975179 10.8119 1.2563 10.4651 1.2563H5.44187C5.09509 1.2563 4.81396 0.975179 4.81396 0.628395Z" fill="#7C7B73"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.2516 12.7959C11.169 12.8434 11.0092 13.0084 11.0092 13.471V15.4217C11.0092 15.8844 11.169 16.0493 11.2516 16.0969C11.3339 16.1443 11.5567 16.2002 11.9581 15.9671L13.6325 14.9959C14.0359 14.7617 14.0985 14.5408 14.0985 14.4464C14.0985 14.352 14.0359 14.131 13.6325 13.8968L11.9584 12.9258C11.5569 12.6927 11.3339 12.7485 11.2516 12.7959ZM12.5885 11.8395C11.9518 11.4699 11.2287 11.3597 10.6246 11.7078C10.0206 12.0558 9.75342 12.7365 9.75342 13.471V15.4217C9.75342 16.1563 10.0206 16.8369 10.6246 17.185C11.2288 17.5331 11.952 17.4228 12.5887 17.0531L14.2629 16.0821C14.8976 15.7135 15.3543 15.1431 15.3543 14.4464C15.3543 13.7496 14.8979 13.1794 14.2631 12.8108L12.5885 11.8395C12.5885 11.8395 12.5884 11.8394 12.5885 11.8395Z" fill="#7C7B73"/>
      </svg>
    ),
    "/chart":(
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1.54437 1.54486C2.6616 0.427633 4.33342 0.000488281 6.48837 0.000488281H11.5116C13.6666 0.000488281 15.3384 0.427633 16.4556 1.54486C17.5729 2.66209 18 4.33391 18 6.48886V11.5121C18 13.6671 17.5729 15.3389 16.4556 16.4561C15.3384 17.5733 13.6666 18.0005 11.5116 18.0005H6.48837C4.33342 18.0005 2.6616 17.5733 1.54437 16.4561C0.427145 15.3389 0 13.6671 0 11.5121V6.48886C0 4.33391 0.427145 2.66209 1.54437 1.54486ZM2.43237 2.43286C1.66588 3.19935 1.25581 4.45777 1.25581 6.48886V11.5121C1.25581 13.5432 1.66588 14.8016 2.43237 15.5681C3.19886 16.3346 4.45728 16.7447 6.48837 16.7447H11.5116C13.5427 16.7447 14.8011 16.3346 15.5676 15.5681C16.3341 14.8016 16.7442 13.5432 16.7442 11.5121V6.48886C16.7442 4.45777 16.3341 3.19935 15.5676 2.43286C14.8011 1.66637 13.5427 1.2563 11.5116 1.2563H6.48837C4.45728 1.2563 3.19886 1.66637 2.43237 2.43286Z" fill="#7C7B73"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.62791 5.23305C9.62791 3.96533 10.6625 2.93072 11.9302 2.93072C13.1979 2.93072 14.2326 3.96533 14.2326 5.23305V12.7679C14.2326 14.0356 13.1979 15.0703 11.9302 15.0703C10.6521 15.0703 9.62791 14.0336 9.62791 12.7679V5.23305ZM11.9302 4.18653C11.3561 4.18653 10.8837 4.6589 10.8837 5.23305V12.7679C10.8837 13.3441 11.3498 13.8144 11.9302 13.8144C12.5044 13.8144 12.9767 13.3421 12.9767 12.7679V5.23305C12.9767 4.6589 12.5044 4.18653 11.9302 4.18653Z" fill="#7C7B73"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M3.76744 9.8377C3.76744 8.56998 4.80205 7.53537 6.06977 7.53537C7.33748 7.53537 8.37209 8.56998 8.37209 9.8377V12.7679C8.37209 14.0356 7.33748 15.0703 6.06977 15.0703C4.79164 15.0703 3.76744 14.0336 3.76744 12.7679V9.8377ZM6.06977 8.79119C5.49562 8.79119 5.02326 9.26355 5.02326 9.8377V12.7679C5.02326 13.3441 5.48929 13.8144 6.06977 13.8144C6.64391 13.8144 7.11628 13.3421 7.11628 12.7679V9.8377C7.11628 9.26355 6.64391 8.79119 6.06977 8.79119Z" fill="#7C7B73"/>
      </svg>
    )
  }
};
